import s from "@pages/fid_view/styles.module.css"
import { CardActions } from "@mui/material"
import React, { FC, useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi"
import { show } from "@pages/signIn/SignInSlice"

import SimpleSharedDialog from "@components/Dialogs/SimpleSharedDialog"
import SubmitGradientButton from "@components/Buttonts/SubmitGradientButton"
import Typography from "@mui/material/Typography"
import { getLinkFromEvent } from "@utils/event.link.utils"
import ConfirmationDialog from "@components/Dialogs/ConfirmationDialog"
import useEventApi from "../../../app/data/eventsSubscription"
import useCredentials from "@utils/useCredentials"
import { useAppDispatch } from "@app/hooks"

export interface HeaderContentProps {
  title?: string
  eventInfo?: DetailedEventInSearchDto
}
const HeaderContent: FC<HeaderContentProps> = ({ eventInfo }) => {
  if (!eventInfo) return null
  const [btnTitle, setBtnTitle] = useState<string>("Я пойду")
  const [disabled, setDisabled] = useState<boolean>(false)
  const { is_private, is_want_to_go, is_participant } = eventInfo
  const credentials = useCredentials()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [openSubscribeDialog, setOpenSubscribeDialog] = useState<boolean>(false)
  const eventApi = useEventApi()
  // @ts-ignore
  const isOrganizer = credentials.userId === eventInfo.organizer_id
  const handleClick = async () => {
    if (credentials.isAuthenticated) {
      const { userId } = credentials
      let result: object | null = null
      try {
        if (is_private) {
          result = await eventApi.participant.requestPrivate(
            eventInfo.event_id,
            userId,
          )
        } else {
          result = await eventApi.participant.requestPublic(
            eventInfo.event_id,
            userId,
          )
        }
        if (result) {
        }
      } catch (error) {
      } finally {
        setOpenSubscribeDialog(false)
      }
    }
  }
  useEffect(() => {
    if (isOrganizer) {
      setBtnTitle("Редактировать")
      setDisabled(false)
    }
    if (is_participant && !isOrganizer) {
      setBtnTitle("Вы идете на это событие")
      setDisabled(true)
    }
    if (is_private && !isOrganizer) {
      setBtnTitle("Подать заявку")
      setDisabled(false)
    }
    if (is_private && is_want_to_go) {
      setBtnTitle("Вы подали заявку на участие")
      setDisabled(true)
    }
  }, [is_private, is_want_to_go, is_participant, isOrganizer])

  const switchToEventEditing = () => navigate("editing")
 
  const capitalize = (str: string) => str[0].toUpperCase() + str.slice(1)
  const openConfirmDialog = () => {
    if (credentials.isAuthenticated) {
      setOpenSubscribeDialog(true)
    } else {
      dispatch(show())
    }
    //eventApi.participant.requestPublic()
  }

  return (
    <>
      <h3 className={s.title}>{capitalize(eventInfo?.event_name) ?? null}</h3>
      <CardActions
        sx={{
          display: "flex",
          p: 0,
          m: 0,
          width: "fit-content",
        }}
      >
        <SubmitGradientButton disabled={disabled} onClick={isOrganizer ? switchToEventEditing : openConfirmDialog}>
          <Typography textTransform={"none"} marginX={4} color={"#FFF"}>
            {btnTitle}
          </Typography>
        </SubmitGradientButton>
        <SimpleSharedDialog sharedLink={getLinkFromEvent(eventInfo.event_id)} />
      </CardActions>
      <ConfirmationDialog
        open={openSubscribeDialog}
        onAgree={handleClick}
        onClose={() => setOpenSubscribeDialog(false)}
      />
    </>
  )
}
export default HeaderContent
